// extracted by mini-css-extract-plugin
module.exports = {"noAvatar":"_237pu","avatarImage":"_38YBe","hidden":"OF7Cn","qsAvatarWrapper":"_1OyIi","small":"_38b3n","medium":"L0AS3"};